import React from 'react';
import PropTypes from 'prop-types';
import { HeaderItems, Title } from './style';

export const OrderGroupHeader = ({ title, subtitle, headerDate = true }) => (
  <HeaderItems>
    <Title>{title}</Title>
    {subtitle && headerDate && <div>{subtitle}</div>}
  </HeaderItems>
);

OrderGroupHeader.defaultProps = {
  subtitle: null,
  headerDate: true,
};

OrderGroupHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  headerDate: PropTypes.bool,
};
